var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { AppGenerator } from './generation/generators/app-generator';
import { UiFramework, TableType, Formatter } from './definition/context-types';
import ts, { factory } from "typescript";
import { createEntityFromIntrospection } from './generation/entity/index';
import TemplateResolver from './generation/generators/template/template-resolver';
import { generateGraphqlFile } from '@iteria-app/graphql-lowcode/esm/generate';
import { getListComponentName, getListPageComponentName, getPluralizedEntityName } from './generation/entity/helper';
import { generateMenuItem, generateRoute } from './facade/facadeApi';
// generates CRUD React pages (master-detail, eg. orders list, order detail form) from typescript
export function generatePages(introspection, io, options) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            options === null || options === void 0 ? void 0 : options.names.map(function (typeName) { return __awaiter(_this, void 0, void 0, function () {
                var entity, componentStorageRoot, generatedFolderPath, routeDefinitionFilePath, menuDefinitionFilePath, entityListComponentPageName, listComponentName, listComponentFilePath, listPageComponentFilePath, moduleName, moduleRouteUri, graphqlQueries;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            entity = createEntityFromIntrospection(introspection, typeName);
                            if (!entity) return [3 /*break*/, 5];
                            componentStorageRoot = (_a = options === null || options === void 0 ? void 0 : options.componentStoragePath) !== null && _a !== void 0 ? _a : 'src/components';
                            generatedFolderPath = (_b = options === null || options === void 0 ? void 0 : options.generatedFolderPath) !== null && _b !== void 0 ? _b : 'src/generated';
                            routeDefinitionFilePath = (_c = options === null || options === void 0 ? void 0 : options.routeDefinitionFilePath) !== null && _c !== void 0 ? _c : 'src/routes.tsx';
                            menuDefinitionFilePath = (_d = options === null || options === void 0 ? void 0 : options.menuDefinitionFilePath) !== null && _d !== void 0 ? _d : 'src/layouts/DashboardLayout/NavBar/index.tsx';
                            entityListComponentPageName = getListPageComponentName(entity);
                            listComponentName = getListComponentName(entity);
                            listComponentFilePath = componentStorageRoot + "/" + listComponentName + ".tsx";
                            listPageComponentFilePath = componentStorageRoot + "/" + entityListComponentPageName + ".tsx";
                            moduleName = getPluralizedEntityName(entity.getName());
                            moduleRouteUri = "codegen-" + moduleName;
                            graphqlQueries = generateGraphqlFile(introspection, typeName);
                            if (graphqlQueries != '')
                                io.writeFile(componentStorageRoot + "/" + typeName + ".graphql", graphqlQueries);
                            //generate component for list
                            return [4 /*yield*/, generateListComponent(io, listComponentFilePath, entity, options)
                                //generate page for list component
                            ];
                        case 1:
                            //generate component for list
                            _e.sent();
                            //generate page for list component
                            return [4 /*yield*/, generateListPage(io, entity, typeName, options.pageListTemplate, listPageComponentFilePath, introspection, generatedFolderPath)];
                        case 2:
                            //generate page for list component
                            _e.sent();
                            //generate route for generated list page
                            return [4 /*yield*/, addNewListRoute(io, routeDefinitionFilePath, moduleRouteUri, entityListComponentPageName, listPageComponentFilePath)
                                //generate new menu item for generated list page
                            ];
                        case 3:
                            //generate route for generated list page
                            _e.sent();
                            //generate new menu item for generated list page
                            return [4 /*yield*/, addNewMenuItem(io, menuDefinitionFilePath, moduleName, '/app/' + moduleRouteUri)];
                        case 4:
                            //generate new menu item for generated list page
                            _e.sent();
                            _e.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    });
}
function generateListComponent(io, filePath, entity, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var context, generator, page, sourceFile, printer, pageSourceCode;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    context = {
                        uiFramework: (_a = options === null || options === void 0 ? void 0 : options.uiFramework) !== null && _a !== void 0 ? _a : UiFramework.MaterialUI,
                        formatter: Formatter.None,
                        index: {
                            tableType: (_b = options === null || options === void 0 ? void 0 : options.tableType) !== null && _b !== void 0 ? _b : TableType.BasicTable,
                            height: "400px"
                        }
                    };
                    console.log("GENERATOR: selected table type: " + context.index.tableType);
                    generator = new AppGenerator(context, entity);
                    page = generator.generateListComponent( /* TODO entity / type name should be input - not in context */);
                    sourceFile = ts.createSourceFile(filePath, '', ts.ScriptTarget.ESNext, true, ts.ScriptKind.TSX);
                    printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
                    pageSourceCode = printer.printList(ts.ListFormat.MultiLine, factory.createNodeArray(__spreadArray(__spreadArray([], page.imports), [page.functionDeclaration])), sourceFile);
                    return [4 /*yield*/, io.writeFile(filePath, pageSourceCode)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function generateListPage(io, entity, typeName, pageListTemplateSource, listPageFilePath, introspection, generatedFolderPath) {
    return __awaiter(this, void 0, void 0, function () {
        var templateResolver, listPage, listPageSourceFile, printer, generatedSourceCode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    templateResolver = new TemplateResolver(entity, introspection);
                    listPage = templateResolver.generateListPage(pageListTemplateSource, generatedFolderPath);
                    if (!listPage) return [3 /*break*/, 2];
                    listPageSourceFile = ts.createSourceFile(listPageFilePath, listPage, ts.ScriptTarget.ESNext, true, ts.ScriptKind.TSX);
                    printer = ts.createPrinter({ newLine: ts.NewLineKind.LineFeed });
                    generatedSourceCode = printer.printFile(listPageSourceFile);
                    return [4 /*yield*/, io.writeFile(listPageFilePath, generatedSourceCode)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
function addNewListRoute(io, routeDefinitionFilePath, moduleRouteUri, componentName, componentFilePath) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            generateRoute({
                routeFilePath: routeDefinitionFilePath,
                componentName: componentName,
                componentFilePath: componentFilePath,
                componentRouteUri: moduleRouteUri
            }, io).then(function (generatedSource) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!generatedSource) return [3 /*break*/, 2];
                            return [4 /*yield*/, io.writeFile(routeDefinitionFilePath, generatedSource)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    });
}
function addNewMenuItem(io, menuDefinitionFilePath, itemTitle, itemUri, icon) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            generateMenuItem({
                menuDefinitionFilePath: menuDefinitionFilePath,
                itemTitle: itemTitle,
                itemUri: itemUri,
                itemIcon: icon
            }, io)
                .then(function (generatedSource) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!generatedSource) return [3 /*break*/, 2];
                            return [4 /*yield*/, io.writeFile(menuDefinitionFilePath, generatedSource)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    });
}
